import { IDevice } from "@formant/core/model/IDevice";
import { IOnvifDevice } from "@formant/core/model/IOnvifDevice";

export function videoIpDevicesForDevices(
    devices: IDevice[] | undefined,
): IOnvifDevice[] {
    return (
        (devices &&
            devices
                .reduce<IOnvifDevice[]>(
                    (acc, _) => [
                        ...acc,
                        ...(_.state?.hwInfo?.onvifDevices || []),
                    ],
                    [],
                )
                .sort((a, b) => a.name.localeCompare(b.name))
                .filter(
                    (_, index, array) =>
                        array.findIndex(e => e.address === _.address) === index,
                )) ||
        []
    );
}
